import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetReminderAnalyticsAction } from '@/application/actions';
import type {
  ReminderAnalyticsQuery,
  ReminderAnalyticsReportDTO,
} from '@/domain/repositories/IReportRepository';

export const useReminderAnalytics = (query: ReminderAnalyticsQuery) => {
  const [report, setReport] = useState<ReminderAnalyticsReportDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const queryKey = JSON.stringify(query);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetReminderAnalyticsAction>(
        TYPES.GetReminderAnalyticsAction
      );
      setReport(await action.execute(JSON.parse(queryKey) as ReminderAnalyticsQuery));
    } catch (err) {
      setError(err instanceof Error ? err : new Error('No se pudo cargar el reporte'));
    } finally {
      setIsLoading(false);
    }
  }, [queryKey]);

  useEffect(() => {
    void load();
  }, [load]);

  return { report, isLoading, error, refetch: load };
};
